import type { PreviewNotes } from "~types/types";

export const PREVIEW_NOTES: PreviewNotes = {
    curationName: "BELOW FOLD: 4-Up Video-Only",
    description: "4-Up module designed to house 4 videos.",
    links: [
        {
            name: "Module Library",
            url: "https://docs.google.com/document/d/1JORaUFwMtPyyoUflTRHKINyllR4zWIJV1bL66Abutis/edit?tab=t.0#heading=h.drwk1gookuzk",
        },
        {
            name: "Figma",
            url: "https://www.figma.com/design/ecuKF9CTetHX35z2BJ8oa5/%F0%9F%90%A6%E2%80%8D%F0%9F%94%A5-Phoenix-Module-Repo?node-id=36-3512&m=dev",
        },
    ],
};
